import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import RequestManager from 'more/RequestManager';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import locale from 'dojo/date/locale';
import template from './VehicleBooking.html?raw';
// Template-only widgets (used via data-dojo-type in VehicleBooking.html, not as values in code) → bare imports.
// Original imported HintBox with the wrong casing "moreCore/UI/HintBox/Hintbox" — repointed to canonical HintBox/HintBox.
import "../../../moreCore/UI/HintBox/HintBox";
import "../../../moreCore/UI/DateTimeInput/DateTimeInput";
// NOTE (JS2TS): dropped dead deps (dojo/_base/array, dojo/dom, dijit _TemplatedMixin/_WidgetsInTemplateMixin/_WidgetBase,
// dijit form/TextBox/DateTextBox/TimeTextBox, dijit/popup, dojo/_base/connect, dojo/aspect, dojo/window, dojox/widget/Standby
// — none used in code and none in the template). DOM-heavy → dom-construct aliased.
const domConstruct: any = domConstructTyped;

class VehicleBooking extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    vehicleBookingId: any = null;
    selectedVehicleId: any = null;
    SelectedVehicle: any = null;

    standby: any = null;

    _selectedTr: any = null;

    buildRendering(): void {
        super.buildRendering.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this._sendGetVehicleBookingList_Request();
        this._sendGetBookingStatusList_Request();
        this._sendGetCarPools_Request();
        this._sendGetReasonsOfCarBooking_Request();

        //domClass.add(document.body, "claro");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles(this.translate("NavigationTile__Vehicle"), this.translate("NavigationTile__Vehicle"));
    }

    setEmailField(): void {
        var requestManager = new RequestManager();
        requestManager.post(
            window.appRoot + "JDM/GetCurrentUserEmail", {},
            lang.hitch(this, "_setEmailField_Response"),
            lang.hitch(this, "_setEmailField_Error")
        );
    }
    _setEmailField_Response(response: any): void {
        //console.log(response);
        this.contact_email.value = response;
        this._onChange_contact_email();
    }
    _setEmailField_Error(error: any): void {
        console.log(error);
    }

    _onChange_listBookingDetails(): void {
        this._sendGetVehicleBookingList_Request();
    }

    _onClick_resetRequest(): void {
        this._changeState('new_reservation');

        if (this._selectedTr) {
            domClass.remove(this._selectedTr, "selected");
            this._selectedTr = null;
        }

        this._setBookingDetails(null, false);
        this._setVehicleDeatils(null, false, "", false);
        this.sectionForm.scrollIntoView({ behavior: "smooth" });
    }

    _onClick_hideTop(): void {
        this._changeState('list_only');
        this._setBookingDetails(null, false);
        this._setVehicleDeatils(null, false, "", false);

        if (this._selectedTr) {
            domClass.remove(this._selectedTr, "selected");
            this._selectedTr = null;
        }
    }

    _onChangeReasonsOfCarBookingList(): void {
        this._toggleRed(this.ReasonsOfCarBookingList, !domAttr.get(this.ReasonsOfCarBookingList, "value"));
    }

    _onChangeCarPoolList(): void {
        this._toggleRed(this.CarPoolList, !domAttr.get(this.CarPoolList, "value"));
    }

    _onClick_isExternalReques(): void {
        if (this.bIsExternalRequest.checked) {
            this._changeState('show_vehicle');
            this._setVehicleDeatils(null, false, "", true);
        } else {
            this._changeState('new_reservation');
            this._setVehicleDeatils(null, false, "", false);
        };

        this._onChange_start_date();
    }

    _onClick_deleteSelectedVehicle(): void {
        this._changeState('new_reservation');
        this._setVehicleDeatils(null, false, "", false);
    }

    _onChange_estiamted_distance(): void {
        this._toggleRed(this.estiamted_distance, !this._getValidInt(this.estiamted_distance.value));
    }

    _onChange_contact_email(): void {
        this._toggleRed(this.contact_email, this.contact_email.value.indexOf("@", 0) == -1);
    }

    _onChange_telephone_numer(): void {
        this._toggleRed(this.telephone_numer, !this.telephone_numer.value);
    }

    _onChange_department(): void {
        this._toggleRed(this.department, !this.department.value);
    }

    _onChange_time(): void {
    }
    _onChange_start_date(): void {

        let startDate = this.start_date.getValue()?.date;
        let endDate = this.end_date.getValue()?.date;
        if (!endDate) this.end_date.setValue(startDate, true);

        this.checkDates();

    }
    _onChange_end_date(): void {
        this.checkDates();
    }

    checkDates(): void {

        let endDate = this.end_date.getValue()?.date;
        let startDate = this.start_date.getValue()?.date;
        let now = new Date();

        let bInvalidStart = !startDate
        let bInvalidEnd = !endDate;

        if (startDate) {
            if (startDate.valueOf() < now.valueOf()) {
                bInvalidStart = true;
            }
        }
        if (endDate && startDate) {
            if (endDate.valueOf() < startDate.valueOf()) {
                bInvalidEnd = true;
            }
        }

        this._toggleRed(this.start_date.domNode.parentElement, bInvalidStart);
        this._toggleRed(this.end_date.domNode.parentElement, bInvalidEnd);

        this._onChange_time();
    }

    checkCostCenterAndCoNr(): void {
        let valueCostcenter = this.costcenter_input.get("value");
        let valueCoNr = this.coNr_input.value;

        this.disableNode(this.sectionCostCenter, !!valueCoNr);
        this.disableNode(this.sectionCoNr, !!valueCostcenter);

        if (valueCoNr || valueCostcenter) {
            this._toggleRed(this.costcenter_input.domNode, false);
            this._toggleRed(this.coNr_input, false);
        } else {
            this._toggleRed(this.costcenter_input.domNode, true);
            this._toggleRed(this.coNr_input, true);
        }

    }

    _onClickVehicleBooking_Storno(): void {

        var dialog: any = new GenericDialog();
        dialog.set("content", "Wollen Sie diese Fahrzeugreservierung wirklich stornieren?"); // vehicleBooking_StornoDialog);
        dialog.set("callback", lang.hitch(this, "_onVehicleBooking_Storno"));
        //dialog.set("heading", this.ReasonOfCarBooking.)
        dialog.set("cancel", false);
        dialog.set("ok", false);
        dialog.set("yesBtn", true);
        dialog.set("noBtn", true);
        dialog.open();
    }
    _onVehicleBooking_Storno(result: any): void {
        //console.log('_onVehicleBooking_Storno');
        this.StandbyStart(this.sectionForm)

        if (result >= 1 && this.vehicleBookingId !== null) {

            var stornoData = {
                vehicleBookingId: this.vehicleBookingId
            };
            var stornoString = JSON.stringify(stornoData);

            var requestManager = new RequestManager();
            requestManager.callfunction(
                "VehicleBooking_StornoBooking",
                stornoData,
                lang.hitch(this, "_onStorno_Response"),
                lang.hitch(this, "_onStorno_Error"),
                true
            );
            //console.log(stornoString, stornoData);
        }
    }
    _onStorno_Response(result: any): void {
        this.StandbyStop();
        //console.log('_onStorno_Response', result);
        this._sendGetVehicleBookingList_Request();
        this._changeState('list_only', "");
        this._setVehicleDeatils(null);
        this.div_reservationDeatil.scrollIntoView({ behavior: "smooth" });

    }
    _onStorno_Error(error: any): void {
        this.StandbyStop();

        let dlg: any = new GenericDialog();
        dlg.show(error.Message, "Stornierung Fehler", null, null, "close");

        this.StandbyStop();
    }

    _onClick_isBefFahrt(): void {
        //console.log(this.isBefoerderungsfahrt.checked);
        if (this.isBefoerderungsfahrt.checked) {
            domAttr.set(this.befFahrtNummer, "disabled", false);
        }
        else {
            domAttr.set(this.befFahrtNummer, "disabled", true);
        }
    }


    _searchVals: any = [
        {
            key: "rentBegin",
            errorMsg: "'Buchungsanfang' muss für Suche angegeben sein",
            getVal: function (x: any) {
                return x.start_date.getValue()?.date ? x.toLocalISOString(x.start_date.getValue().date) : null;
            }
        }, {
            key: "rentEnd",
            errorMsg: "'Buchungsende' muss für Suche angegeben sein",
            getVal: function (x: any) {
                return x.end_date.getValue()?.date ? x.toLocalISOString(x.end_date.getValue().date) : null;
            }
        }, {
            key: "QuantitySeats",
            errorMsg: "Ungültiger Wert bei 'Anzahl Sitze'",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantitySeats.value))) ? null : x._getValidInt(x.QuantitySeats.value);
            }
        }, {
            key: "QuantityWheelchair",
            errorMsg: "Ungültiger Wert bei 'Anzahl Rollstühle'",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantityWheelchair.value))) ? null : x._getValidInt(x.QuantityWheelchair.value);
            }
        }, {
            key: "QuantityRunner",
            errorMsg: "Ungültiger Wert bei 'Anzahl Läufer'",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantityRunner.value))) ? null : x._getValidInt(x.QuantityRunner.value);
            }
        }, {
            key: "QuantityWheelchairTranslator",
            errorMsg: "Fehler bei der Eingabe der 'Anzahl Umsetzer-Rollstühle'",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantityWheelchairTranslator.value))) ? null : x._getValidInt(x.QuantityWheelchairTranslator.value);
            }
        }, {
            key: "carPool",
            errorMsg: "'Fuhrpark' muss für Suche angegeben sein",
            getVal: function (x: any) {
                return (domAttr.get(x.CarPoolList, "value")) ? domAttr.get(x.CarPoolList, "value") : null;
            }
        }, {
            key: "IsWheelchairRebuilding",
            getVal: function (x: any) {
                return x.IsWheelchairRebuilding.checked;
            }
        }, {
            key: "IsElectricalWheelchair",
            getVal: function (x: any) {
                return x.IsElectricalWheelchair.checked;
            }
        }, {
            key: "IsTrailerCoupling",
            getVal: function (x: any) {
                return x.IsTrailerCoupling.checked;
            }
        }, {
            key: "bIsLongWheelbase",
            getVal: function (x: any) {
                return x.bIsLongWheelbase.checked;
            }
        }, {
            key: "IsFan",
            getVal: function (x: any) {
                return x.bIsFan.checked;
            }
        }, {
            key: "IsStepTread",
            getVal: function (x: any) {
                return x.bIsStepTread.checked;
            }
        }
    ];
    _onClick_sendSearch(): void {

        var errorMessage = this._searchVals.filter(
            function (this: any, x: any) {
                return x.getVal(this) === null;
            }, this).map(function (x: any) { return x.errorMsg; }).join("<br />\n");
        if (errorMessage !== "") {
            let dlg: any = new GenericDialog();
            dlg.show(errorMessage, "Fehlende Pflichtfelder", null, null, "ok");
            this.messageNode.innerHTML = "<span style='color: red;'>" + errorMessage + "</span>";

        } else {
            this.messageNode.innerHTML = "";
            this.StandbyStart();

            var data = this._searchVals.map(function (this: any, x: any) { return { key: x.key, val: x.getVal(this) }; }, this).reduce(function (data: any, x: any) { (data[x.key] = x.val); return data; }, {});
            var searchDataString = JSON.stringify(data);

            var requestManager = new RequestManager();
            requestManager.post(
                window.appRoot + "JDM/SearchVehicle",
                {
                    "JsonData": searchDataString
                },
                lang.hitch(this, "_onSearchVehicle_Response"),
                lang.hitch(this, "_onSearchVehicle_Error")
            );
            //console.log(searchDataString, data);
        }
    }
    _onSearchVehicle_Response(response: any): void {
        var onSearchVehicleResult = domConstruct.create("div");

        if (response.EntityDataArray.length == 0) {
            domConstruct.create("h3", {
                innerHTML: "Kein Fahrzeug verfügbar:",
            }, onSearchVehicleResult);
            domConstruct.create("h5", {
                innerHTML: "Es ist kein Fahrzeug mit diesen Anforderungen verfügbar, möglicherweise ist eines über 'Externe Anfrage' verfügbar." +
                    "<br>" + "Damit Ihre externe Anfrage bearbeitet werden kann, bitten wir Sie, uns eine genehmigte BANF zu schicken.",
            }, onSearchVehicleResult);
        } else {
            domConstruct.create("h3", {
                innerHTML: "Fahrzeug zur Anfrage wählen:",
            }, onSearchVehicleResult);

            for (var i = 0; i < response.EntityDataArray.length; i++) {
                var vehicle = response.EntityDataArray[i];
                var ID = this.PitHelper.getEntityAttributeValue(vehicle, "ID");

                var p = domConstruct.create("p", null, onSearchVehicleResult);

                var input = domConstruct.create("input", {
                    id: ID,
                    type: "radio",
                    name: "onSearchVehicleResult",
                    className: "w3-check pointer",
                    value: ID
                }, p);
                on(input, "change", lang.hitch(this, function (vehicle: any) {
                    this.SelectedVehicle = vehicle;
                }, vehicle));

                domConstruct.create("label", {
                    innerHTML: this.PitHelper.getEntityAttributeValue(vehicle, "dispname"),
                    className: "pointer",
                    for: ID
                }, p);
            }
        };

        var dialog: any = new GenericDialog();
        dialog.addNodeToContent(onSearchVehicleResult);
        dialog.set("callback", lang.hitch(this, "_onSelectVehicle_Response"));
        dialog.set("cancelBtn", true);
        dialog.set("okBtn", true);
        dialog.open();

        this.messageNode.innerHTML = "";
        this.StandbyStop();
    }
    _onSelectVehicle_Response(result: any): void {
        if (result === 1 && this.SelectedVehicle !== null) {
            this._changeState('show_vehicle');
            this._setVehicleDeatils(this.SelectedVehicle, true);
        }
    }
    _onSearchVehicle_Error(error: any): void {
        //console.log("_onSearchVehicle_Error");
        let dlg: any = new GenericDialog();
        dlg.show(error.Message, "Suche fehlgeschlagen", null, null, "ok");
        this.messageNode.innerHTML = "<span style='color: red;'>" + error.Message + "</span>";
        this.StandbyStop();
    }


    _bookVals: any = [
        {
            key: "carPool",
            errorMsg: "'Fuhrpark' wurde nicht angegeben",
            getVal: function (x: any) {
                return (x.bIsExternalRequest.checked ? "ext" : domAttr.get(x.CarPoolList, "value")) ? domAttr.get(x.CarPoolList, "value") : null;
            }
        }, {
            key: "rentBegin",
            errorMsg: "'Buchungsanfang' wurde nicht angegeben",
            getVal: function (x: any) {
                return x.start_date.getValue()?.date ? x.toLocalISOString(x.start_date.getValue().date) : null;
            }

        }, {
            key: "rentEnd",
            errorMsg: "'Buchungsende' wurde nicht angegeben",
            getVal: function (x: any) {
                return x.end_date.getValue()?.date ? x.toLocalISOString(x.end_date.getValue().date) : null;
            }

        }, {
            key: "costcenter",
            errorMsg: "'Kostenstelle' und 'CO-Nummer' nicht eingetragen - bitte mindestens eines davon angeben",
            getVal: function (x: any) {
                let valCostCenter = x.costcenter_input.get("value");
                let valueCoNr = x.coNr_input.value;

                if (!valCostCenter && !valueCoNr) return null;
                return valCostCenter ? x.PitHelper.getEntityAttributeValue(valCostCenter, "ID") : "";
            }
        }, {
            key: "co_nr",
            //errorMsg: "'CO-Nummer' wurde nicht angegeben",
            getVal: function (x: any) {
                return (domAttr.get(x.coNr_input, "value")) ? domAttr.get(x.coNr_input, "value") : "";
            }
        }, {
            key: "startPostalCode",
            errorMsg: "'Startort' ungültig",
            getVal: function (x: any) {
                return (x.start_postal_code.get("value")) ? x.PitHelper.getEntityAttributeValue(x.start_postal_code.get("value"), "ID") : null;
            }
        }, {
            key: "endPostalCode",
            errorMsg: "'Zielort' ungültig",
            getVal: function (x: any) {
                return (x.end_postal_code.get("value")) ? x.PitHelper.getEntityAttributeValue(x.end_postal_code.get("value"), "ID") : null;
            }
        }, {
            key: "distance",
            errorMsg: "'geschätzte Fahrstrecke' ungültig",
            getVal: function (x: any) {
                return (x._getValidInt(x.estiamted_distance.value) > 0) ? x._getValidInt(x.estiamted_distance.value) : null;
            }
        }, {
            key: "QuantitySeats",
            errorMsg: "'Anzahl Sitze' ungültig",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantitySeats.value))) ? null : x._getValidInt(x.QuantitySeats.value);
            }
        }, {
            key: "QuantityWheelchair",
            errorMsg: "'Anzahl Rollstühle' ungültig",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantityWheelchair.value))) ? null : x._getValidInt(x.QuantityWheelchair.value);
            }
        }, {
            key: "QuantityRunner",
            errorMsg: "'Anzahl Läufer' ungültig",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantityRunner.value))) ? null : x._getValidInt(x.QuantityRunner.value);
            }
        }, {
            key: "QuantityWheelchairTranslator",
            errorMsg: "'Anzahl Umsetzer-Rollstühle' ungültig",
            getVal: function (x: any) {
                return (isNaN(x._getValidInt(x.QuantityWheelchairTranslator.value))) ? null : x._getValidInt(x.QuantityWheelchairTranslator.value);
            }
        }, {
            key: "ReasonsOfCarBooking",
            errorMsg: "'Fahrtgrund' wurde nicht angegeben",
            getVal: function (x: any) {
                return (domAttr.get(x.ReasonsOfCarBookingList, "value")) ? domAttr.get(x.ReasonsOfCarBookingList, "value") : null;
            }
        }, {
            key: "IsWheelchairRebuilding",
            getVal: function (x: any) {
                return x.IsWheelchairRebuilding.checked;
            }
        }, {
            key: "IsElectricalWheelchair",
            getVal: function (x: any) {
                return x.IsElectricalWheelchair.checked;
            }
        }, {
            key: "IsTrailerCoupling",
            getVal: function (x: any) {
                return x.IsTrailerCoupling.checked;
            }
        }, {
            key: "bIsLongWheelbase",
            getVal: function (x: any) {
                return x.bIsLongWheelbase.checked;
            }
        }, {
            key: "IsFan",
            getVal: function (x: any) {
                return x.bIsFan.checked;
            }
        }, {
            key: "IsStepTread",
            getVal: function (x: any) {
                return x.bIsStepTread.checked;
            }
        }, {
            key: "note",
            getVal: function (x: any) {
                return domAttr.get(x.vehicle_note, "value");
            }
        }, {
            key: "contact_email",
            errorMsg: "'Kontakt Emailadresse' wurde nicht angegeben",
            getVal: function (x: any) {
                return (x.contact_email.value.indexOf("@", 0) == -1) ? null : domAttr.get(x.contact_email, "value");
            }
        }, {
            key: "telephone_numer",
            errorMsg: "'Telefonnummer' wurde nicht angegeben",
            getVal: function (x: any) {
                return (domAttr.get(x.telephone_numer, "value")) ? domAttr.get(x.telephone_numer, "value") : null;
            }
        }, {
            key: "department",
            errorMsg: "'Gruppe/Abteilung' wurde nicht angegeben",
            getVal: function (x: any) {
                return (domAttr.get(x.department, "value")) ? domAttr.get(x.department, "value") : null;
            }
        }, {
            key: "IsExternalRequest",
            getVal: function (x: any) {
                return x.bIsExternalRequest.checked;
            }
        }, {
            key: "selectedVehicle",
            getVal: function (x: any) {
                return x.selectedVehicleId;
            }
        }, {
            key: "IsOneDay",
            errorMsg: "Eine Buchung über mehrere Tage ist nur über 'Externe Anfrage' möglich",
            getVal: function (x: any) {
                return true;
                //return (x.start_date.get("value") && x.end_date.get("value") && x.start_date._getDisplayedValueAttr() != x.end_date._getDisplayedValueAttr() && x.bIsExternalRequest.checked == false) ?
                //    null : true;
            }
        }, {
            key: "IsTransport",
            getVal: function (x: any) {
                /*if (x.bIsExternalRequest.checked) {
                    return x.isBefoerderungsfahrt.checked;
                }
                else {
                    return false;
                }*/
                return x.isBefoerderungsfahrt.checked;
            }
        }, {
            key: "TransportNumber",
            getVal: function (x: any) {
                /*if (x.bIsExternalRequest.checked) {
                    return domAttr.get(x.befFahrtNummer, "value");
                }
                else {
                    return "";
                }*/
                return domAttr.get(x.befFahrtNummer, "value");
            }
        }
    ];
    _onClick_sendBooking(): void {
        var errorMessage = this._bookVals.filter(function (this: any, x: any) { return x.getVal(this) === null; }, this).map(function (x: any) { return x.errorMsg; }).join("<br />\n");
        if (errorMessage !== "") {
            this.messageNode.innerHTML = "<span style='color: red;'>" + errorMessage + "</span>";
            let dlg: any = new GenericDialog();
            dlg.show(errorMessage, "Fehlende Pflichtfelder", null, null, "ok");
        } else {
            this.messageNode.innerHTML = "";
            this.StandbyStart();

            var data = this._bookVals.map(function (this: any, x: any) { return { key: x.key, val: x.getVal(this) }; }, this).reduce(function (data: any, x: any) { (data[x.key] = x.val); return data; }, {});
            var dataString = JSON.stringify(data);
            var requestManager = new RequestManager();
            requestManager.callfunction(
                "VehicleBooking_SaveFormData",
                data,
                lang.hitch(this, "_onBooking_Response"),
                lang.hitch(this, "_onBooking_Error"),
                true
            );
            //console.log(dataString, data);
        }
    }
    _onBooking_Response(): void {
        this._sendGetVehicleBookingList_Request();
        this._changeState('list_only', "");
        this._setVehicleDeatils(null);
        scrollTo(0, 0);
    }
    _onBooking_Error(error: any): void {
        this.messageNode.innerHTML = "<span style='color: red;'>" + error.Message + "</span>";
        this.StandbyStop();
    }


    _sendGetVehicleBookingList_Request(): void {
        this.messageNode.innerHTML = "";
        this.StandbyStart(this.div_reservationDeatil)

        let data = {
            "sort": domAttr.get(this.list_sort_view, "value"),
            "status": domAttr.get(this.list_booking_status, "value")
        };

        var requestManager = new RequestManager();
        requestManager.callfunction(
            "Webtool_API_VehicleReservations__GetFilterResults",
            data,
            lang.hitch(this, "_onGetVehicleBookingList_Response"),
            lang.hitch(this, "_onGetVehicleBookingLists_Error")
        );
    }
    _onGetVehicleBookingList_Response(response: any): void {
        var entitylist = response;

        domConstruct.empty(this.tableCarBookingList);
        for (var i = 0; i < entitylist.length; i++) {
            var VehicleBooking = entitylist[i];

            var startLocation = this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_postal_code_start.Location");
            var endLocation = this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_postal_code.Location");

            var tr = domConstruct.create("tr", null, this.tableCarBookingList);

            var status = domConstruct.create("td", {
                innerHTML: this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_status.Name"),
                class: "status"
            }, tr);
            var backColor = VehicleBooking.ref_status?.Coloration?.BackColor?.Hex;
            var txtColor = VehicleBooking.ref_status?.Coloration?.TextColor?.Hex;
            if (backColor) domStyle.set(status, "backgroundColor", backColor);
            if (txtColor) domStyle.set(status, "color", txtColor);

            let begin = this.PitHelper.getEntityAttributeValue(VehicleBooking, "Rent_begin");
            if (begin) {
                let date = new Date(begin);
                begin = locale.format(date, { formatLength: "short", locale: "de" } as any)
            }

            let end = this.PitHelper.getEntityAttributeValue(VehicleBooking, "Rent_end");
            if (end) {
                let date = new Date(end);
                end = locale.format(date, { formatLength: "short", locale: "de" } as any)
            }
            var zeitraum = domConstruct.create("td", {
                innerHTML:
                    begin + "<br />" +
                    end,
                class: "zeitraum"
            }, tr);

            if (this.PitHelper.getEntityAttributeValue(VehicleBooking, "is_request_external_vehicle") == 1) {
                var vehicleText: any = "Externe Anfrage"
            } else if (this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_vehicle.dispname") != null) {
                var vehicleText =
                    this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_car_pool.name") +
                    this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_vehicle.dispname")
            } else {
                var vehicleText: any = "Kein Fahrzeug ausgewählt";
            }

            var info = domConstruct.create("td", {
                innerHTML:
                    this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_Reason_drive.Name") + " (" +
                    startLocation + ((startLocation == endLocation) ? "" : " - " + endLocation) + ")<br />" +
                    vehicleText,
            }, tr);

            on(tr, "click", lang.hitch(this, "_onVehicleBooking_Select", VehicleBooking, tr));
        }
        this.messageNode.innerHTML = "";
        this.StandbyStop();
    }
    _onVehicleBooking_Select(VehicleBooking: any, tr: any): void {
        this._changeState('show_reservation', null, VehicleBooking);
        this._setBookingDetails(VehicleBooking, true);
        this._setVehicleDeatils(VehicleBooking, true, "ref_vehicle.", this.PitHelper.getEntityAttributeValue(VehicleBooking, "is_request_external_vehicle") == 1);

        domClass.add(tr, "selected");
        if (this._selectedTr) {
            domClass.remove(this._selectedTr, "selected");
            this._selectedTr = null;
        }

        this._selectedTr = tr;

        this.sectionForm.scrollIntoView({ behavior: "smooth" });
    }
    _onGetVehicleBookingLists_Error(error: any): void {
        //console.log("_onGetVehicleBookingLists_Error");
        this.messageNode.innerHTML = "<span style='color: red;'>" + error.Message + "</span>";
        this.StandbyStop();
    }


    _sendGetBookingStatusList_Request(): void {
        var requestManager = new RequestManager();
        requestManager.post(
            window.appRoot + "JDM/GetBookingStatusList", {},
            lang.hitch(this, "_onGetBookingStatusList_Response"),
            lang.hitch(this, "_onGetBookingStatusList_Error")
        );
    }
    _onGetBookingStatusList_Response(response: any): void {
        for (var i = 0; i < response.EntityDataArray.length; i++) {
            var Status = response.EntityDataArray[i];
            domConstruct.create("option", {
                innerHTML: this.PitHelper.getEntityAttributeValue(Status, "Name"),
                value: this.PitHelper.getEntityAttributeValue(Status, "ID")
            }, this.list_booking_status);
        }
    }
    _onGetBookingStatusList_Error(error: any): void {
        //console.log("_onGetBookingStatus_Error");

        this.messageNode.innerHTML = "<span style='color: red;'>" + error.Message + "</span>";
    }


    _sendGetCarPools_Request(): void {
        var requestManager = new RequestManager();
        requestManager.post(
            window.appRoot + "JDM/GetCarPools", {},
            lang.hitch(this, "_onGetCarPools_Response"),
            lang.hitch(this, "_onGetCarPools_Error")
        );
    }
    _onGetCarPools_Response(response: any): void {
        for (var i = 0; i < response.EntityDataArray.length; i++) {
            var CarPool = response.EntityDataArray[i];
            domConstruct.create("option", {
                innerHTML: this.PitHelper.getEntityAttributeValue(CarPool, "name"),
                value: this.PitHelper.getEntityAttributeValue(CarPool, "ID")
            }, this.CarPoolList);
        }
    }
    _onGetCarPools_Error(error: any): void {
        //console.log("_onGetCarPools_Error");
        this.messageNode.innerHTML = "<span style='color: red;'>Fuhrpark wurde nicht geladen: " + error.Message + "</span>";
    }


    _sendGetReasonsOfCarBooking_Request(): void {
        var requestManager = new RequestManager();
        requestManager.post(
            window.appRoot + "JDM/GetReasonsOfCarBooking", {},
            lang.hitch(this, "_onGetReasonsOfCarBooking_Response"),
            lang.hitch(this, "_onGetReasonsOfCarBooking_Error")
        );
    }
    _onGetReasonsOfCarBooking_Response(response: any): void {
        for (var i = 0; i < response.EntityDataArray.length; i++) {
            var ReasonOfCarBooking = response.EntityDataArray[i];
            domConstruct.create("option", {
                innerHTML: this.PitHelper.getEntityAttributeValue(ReasonOfCarBooking, "Name"),
                value: this.PitHelper.getEntityAttributeValue(ReasonOfCarBooking, "ID")
            }, this.ReasonsOfCarBookingList);
        }
    }
    _onGetReasonsOfCarBooking_Error(error: any): void {
        //console.log("_onGetReasonsOfCarBooking_Error");
        this.messageNode.innerHTML = "<span style='color: red;'>" + error.Message + "</span>";
    }


    _getValidInt(val: any): any {
        return parseInt(Number(val.replace(/,/g, '.')) as any);
    }

    _toggleClasses(node: any, condition: any, classes: any): void {
        if (node) {
            classes.forEach(function (c: any) { domClass.toggle(node, c, condition); }, this);
        }
    }

    _togglePointer(node: any, isPointer: any): void {
        this._toggleClasses(node, isPointer, ["pointer"])
    }

    _toggleRed(node: any, isRed: any): void {
        this._toggleClasses(node, isRed, ["w3-pale-red", "w3-border-red"])
    }

    _toggleWhite(node: any, isOverride: any): void {
        this._toggleClasses(node, isOverride, ["w3-text-black", "w3-white"])
    }

    _setNodeToPitColor(node: any, AttributeDisplayColor: any): void {
        var BackColor = AttributeDisplayColor.BackColor;
        var TextColor = AttributeDisplayColor.TextColor;

        if (TextColor.Active === false) {
            if (!this.PitHelper.IsDarkColor(BackColor)) {
                TextColor = {
                    RValue: 0,
                    BValue: 0,
                    GValue: 0
                };
            } else {
                TextColor = {
                    RValue: 255,
                    BValue: 255,
                    GValue: 255
                };
            }
        }
        domStyle.set(node, "background", "rgb(" + BackColor.RValue + ", " + BackColor.GValue + ", " + BackColor.BValue + ")");
    }

    _setState(div_searchDeatils: any,
        div_vehicleDetails: any,
        btn_send: any,
        btn_book: any,
        btn_reset: any,
        div_removeSelectedVehicle: any,
        btn_storno: any): void {

        this.div_searchDeatils.style.display = div_searchDeatils;
        this.div_vehicleDetails.style.display = div_vehicleDetails;

        this.btn_send.style.display = btn_send;
        this.btn_book.style.display = btn_book;
        this.btn_reset.style.display = btn_reset;
        this.btn_storno.style.display = btn_storno;
    }

    _changeState(state: any, message?: any, entity?: any): void {
        if (typeof (message) == "undefined") message = "";

        switch (state) {
            case 'list_only':
                this._setState('none', 'none', 'none', 'none', 'block', 'none', 'none');
                break;
            case 'new_reservation':
                this._setState('block', 'block', 'block', 'none', 'none', 'none', 'none');
                this.setEmailField();
                break;
            case 'show_vehicle':

                this._setState('block', 'block', 'none', 'block', 'none', 'block', 'none');
                break;
            case 'show_reservation':

                this._setState('block', 'block', 'none', 'none', 'none', 'none', 'block');

                if (entity) {
                    let dateStart = new Date(this.PitHelper.getEntityAttributeValue(entity, "Rent_begin"));
                    let now = new Date();
                    if (dateStart.valueOf() < now.valueOf()) {
                        this.disableNode(this.btn_storno);
                    } else {
                        this.disableNode(this.btn_storno, false);
                    }
                }
                break;
        }
        this.messageNode.innerHTML = message;
        //this.hideNode(this.messageNode, !message);
    }

    _setBookingDetails(VehicleBooking: any, isReadonly?: any): void {
        if (typeof (isReadonly) == "undefined") {
            isReadonly = false;
        }
        if (VehicleBooking !== null) {
            this.vehicleBookingId = this.PitHelper.getEntityAttributeValue(VehicleBooking, "ID");

            domAttr.set(this.ReasonsOfCarBookingList, "value", this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_Reason_drive.ID"));
            this._toggleRed(this.ReasonsOfCarBookingList, false);

            this.start_date.setValue(this.PitHelper.getEntityAttributeValue(VehicleBooking, "Rent_begin"), true);
            this.end_date.setValue(this.PitHelper.getEntityAttributeValue(VehicleBooking, "Rent_end"), true);
            this._toggleRed(this.start_date.domNode.parentElement, false);
            this._toggleRed(this.end_date.domNode.parentElement, false);

            let valueCostcenter: any = {
                dispname: this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_cost_center.dispname"),
                ID: this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_cost_center.ID")
            };
            if (!valueCostcenter?.ID) valueCostcenter = null;

            let valueCoNr = this.PitHelper.getEntityAttributeValue(VehicleBooking, "co_number");
            this.costcenter_input.set("value", valueCostcenter);
            this.coNr_input.value = valueCoNr;

            this.checkCostCenterAndCoNr();


            this.start_postal_code.setValue(this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_postal_code_start"), true);
            this._toggleRed(this.start_postal_code.domNode, false);

            this.end_postal_code.setValue(this.PitHelper.getEntityAttributeValue(VehicleBooking, "ref_postal_code"), true);
            this._toggleRed(this.end_postal_code.domNode, false);

            this.estiamted_distance.value = this.PitHelper.getEntityAttributeValue(VehicleBooking, "km_estimate");
            this._toggleRed(this.estiamted_distance, false);

            this.contact_email.value = this.PitHelper.getEntityAttributeValue(VehicleBooking, "email_address");
            this._toggleRed(this.contact_email, false);

            this.telephone_numer.value = this.PitHelper.getEntityAttributeValue(VehicleBooking, "Telephone");
            this._toggleRed(this.telephone_numer, false);

            this.department.value = this.PitHelper.getEntityAttributeValue(VehicleBooking, "department");
            this._toggleRed(this.department, false);

            this.isBefoerderungsfahrt.checked = this.PitHelper.getEntityAttributeValue(VehicleBooking, "is_transport");
            this.befFahrtNummer.value = this.PitHelper.getEntityAttributeValue(VehicleBooking, "transport_number");

            domAttr.set(this.vehicle_note, "value", this.PitHelper.getEntityAttributeValue(VehicleBooking, "Note"));

            if (this.vehicle_note.value == "null") {
                this.vehicle_note.value = "";
            }
        } else {
            this.vehicleBookingId = null;

            this.ReasonsOfCarBookingList.value = "";

            this.start_date.setValue(null);
            this._toggleRed(this.start_date.domNode.parentElement, true);
            this.end_date.setValue(null);
            this._toggleRed(this.end_date.domNode.parentElement, true);

            this.costcenter_input.setValue(null, true);
            this._toggleRed(this.costcenter_input.domNode, true);

            this.coNr_input.value = "";

            this.start_postal_code.setValue(null, true);
            this._toggleRed(this.start_postal_code.domNode, true);

            this.end_postal_code.setValue(null, true);
            this._toggleRed(this.end_postal_code.domNode, true);

            this.estiamted_distance.value = '';
            this._toggleRed(this.estiamted_distance, true);

            this.contact_email.value = '';
            this._toggleRed(this.contact_email, true);

            this.telephone_numer.value = '';
            this._toggleRed(this.telephone_numer, true);

            this.department.value = '';
            this._toggleRed(this.department, true);

            domAttr.set(this.vehicle_note, "value", '');
        }
        this.disableNode(this.ReasonsOfCarBookingList, isReadonly);

        this._togglePointer(this.ReasonsOfCarBookingList, !isReadonly);

        this.disableNode(this.start_date, isReadonly);
        this.disableNode(this.end_date, isReadonly);
        this.disableNode(this.department, isReadonly);
        this.disableNode(this.telephone_numer, isReadonly);

        this.disableNode(this.selectedVehicleDispname, isReadonly);
        this.disableNode(this.QuantityRunner, isReadonly);
        this.disableNode(this.QuantitySeats, isReadonly);
        this.disableNode(this.QuantityWheelchair, isReadonly);
        this.disableNode(this.QuantityWheelchairTranslator, isReadonly);

        this._toggleWhite(this.ReasonsOfCarBookingList, isReadonly);
        this._toggleWhite(this.start_date.domNode.parentElement, isReadonly);
        this._toggleWhite(this.end_date.domNode.parentElement, isReadonly);

        this.disableNode(this.costcenter_input.domNode, isReadonly);
        this.disableNode(this.coNr_input, isReadonly);
        this.disableNode(this.start_postal_code.domNode, isReadonly);
        this.disableNode(this.end_postal_code.domNode, isReadonly);
        this.disableNode(this.estiamted_distance, isReadonly);
        this.disableNode(this.contact_email, isReadonly);

        this.disableNode(this.vehicle_note, isReadonly);

        this.disableNode(this.isBefoerderungsfahrt, isReadonly);
    }

    _setVehicleDeatils(vehicle: any, isReadonly?: any, prefix?: any, isExternalRequest?: any): void {
        if (typeof (isReadonly) == "undefined") isReadonly = false;
        if (typeof (prefix) == "undefined") prefix = "";
        if (typeof (isExternalRequest) == "undefined") isExternalRequest = false;

        if (isExternalRequest) {
            this.div_carPoolList.style.display = "none";
            //this.befFahrtContainer.style.display = "block";
        }
        else {
            this.div_carPoolList.style.display = "block";
            //this.befFahrtContainer.style.display = "none";
        }

        //this.div_carPoolList.style.display = (isExternalRequest) ? "none" : "block";
        //this.befFahrtContainer.style.display = (isExternalRequest) ? "block" : "none";
        this.bIsExternalRequest.checked = isExternalRequest;

        if (vehicle !== null) {
            this.selectedVehicleId = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "ID");
            this.SelectedVehicle = vehicle;

            if (isExternalRequest) {
                this.div_removeSelectedVehicle.style.display = "none";
                this.div_externalRequest.style.display = "block";
                this.div_selectedVehicle.style.display = "none";
            } else {
                this.div_removeSelectedVehicle.style.display = (prefix == "") ? "block" : "none";
                this.div_externalRequest.style.display = "none";
                this.div_selectedVehicle.style.display = "block";
            };
            this.selectedVehicleDispname.innerHTML = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "dispname");
            domAttr.set(this.CarPoolList, "value", this.PitHelper.getEntityAttributeValue(vehicle, prefix + "ref_car_pool.ID"));
            this._toggleRed(this.CarPoolList, false);

            this.QuantitySeats.value = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "quantity_seats");
            this.QuantityWheelchair.value = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "quantity_wheelchair");
            this.QuantityRunner.value = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "quantity_runner");
            this.QuantityWheelchairTranslator.value = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "quantity_wheelchair_translator");

            this.IsWheelchairRebuilding.checked = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "is_wheelchair_rebuilding");
            this.IsElectricalWheelchair.checked = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "is_electrical_wheelchair");
            this.IsTrailerCoupling.checked = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "is_trailer_coupling");
            this.bIsLongWheelbase.checked = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "is_long_wheelbase");
            this.bIsFan.checked = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "is_fan");
            this.bIsStepTread.checked = this.PitHelper.getEntityAttributeValue(vehicle, prefix + "is_step_tread");
        } else {
            this.selectedVehicleId = null;
            this.SelectedVehicle = null;

            this.div_removeSelectedVehicle.style.display = "none";
            this.div_externalRequest.style.display = "block";
            this.div_selectedVehicle.style.display = "none";

            this.selectedVehicleDispname.innerHTML = '';
            this.CarPoolList.value = null;

            this.QuantitySeats.value = '';
            this.QuantityWheelchair.value = '';
            this.QuantityRunner.value = '';
            this.QuantityWheelchairTranslator.value = '';

            this.IsWheelchairRebuilding.checked = false;
            this.IsElectricalWheelchair.checked = false;
            this.IsTrailerCoupling.checked = false;
            this.bIsLongWheelbase.checked = false;
            this.bIsFan.checked = false;
            this.bIsStepTread.checked = false;
        }

        this._togglePointer(this.bIsExternalRequest, !isReadonly);
        this._togglePointer(this.CarPoolList, !isReadonly);
        this._togglePointer(this.IsWheelchairRebuilding, !isReadonly);
        this._togglePointer(this.IsElectricalWheelchair, !isReadonly);
        this._togglePointer(this.IsTrailerCoupling, !isReadonly);
        this._togglePointer(this.bIsLongWheelbase, !isReadonly);
        this._togglePointer(this.bIsFan, !isReadonly);
        this._togglePointer(this.bIsStepTread, !isReadonly);

        this._toggleWhite(this.CarPoolList, isReadonly);

        this.disableNode(this.selectedVehicleDispname, isReadonly);

        this.disableNode(this.CarPoolList, isReadonly);
        this.disableNode(this.QuantitySeats, isReadonly);
        this.disableNode(this.QuantitySeats, isReadonly);
        this.disableNode(this.QuantityWheelchair, isReadonly);
        this.disableNode(this.QuantityRunner, isReadonly);
        this.disableNode(this.QuantityWheelchairTranslator, isReadonly);

        this.disableNode(this.bIsExternalRequest, isReadonly);
        this.disableNode(this.IsWheelchairRebuilding, isReadonly);
        this.disableNode(this.IsElectricalWheelchair, isReadonly);
        this.disableNode(this.IsTrailerCoupling, isReadonly);
        this.disableNode(this.bIsLongWheelbase, isReadonly);
        this.disableNode(this.bIsFan, isReadonly);
        this.disableNode(this.bIsStepTread, isReadonly);

        this.disableNode(this.isBefoerderungsfahrt, isReadonly);
        this.disableNode(this.befFahrtNummer, isReadonly);
        if (isReadonly) {
            domStyle.set(this.isBefoerderungsfahrt, "cursor", "default");
        }
    }

    _onClick_toggleExternDateInfo(): void {
        if (domStyle.get(this.externDateInfoBox, "display") == "none") {
            domStyle.set(this.externDateInfoBox, "display", "block");
        }
        else {
            domStyle.set(this.externDateInfoBox, "display", "none");
        }
    }

    _onChange_transport_number(): void {

    }

    _onChange_is_transport(): void {

    }

    _onChange_costCenter(): void {
        this.checkCostCenterAndCoNr();
    }
    _onChange_coNr(): void {
        this.checkCostCenterAndCoNr();
    }

    _onChange_PostalCodeStart(): void {
        let value = this.start_postal_code.get("value");

        this._toggleRed(this.start_postal_code.domNode, !value);

    }

    _onChange_PostalCodeEnd(): void {
        let value = this.end_postal_code.get("value");

        this._toggleRed(this.end_postal_code.domNode, !value);
    }
}
VehicleBooking.prototype.declaredClass = 'WidgetCollection.VehicleBooking';

export default mdsWidget(VehicleBooking);
